/**
 * Profile Links API Service
 *
 * The web links on a prospect's profile (baseball only).
 */

import { del, get, post } from './api';
import type { CreateProspectLinkRequest, ProspectLink } from '../types/prospect-links';

const basePath = (prospectId: string) => `/api/prospects/${prospectId}/links`;

/** Live links, oldest first. */
export const getProspectLinks = (prospectId: string): Promise<ProspectLink[]> =>
  get<ProspectLink[]>(basePath(prospectId));

/**
 * Adds a link. Rejects with an `ApiError` whose message is safe to show the coach
 * (invalid address, duplicate, 100-link cap, softball program).
 */
export const createProspectLink = (
  prospectId: string,
  request: CreateProspectLinkRequest,
): Promise<ProspectLink> => post<ProspectLink>(basePath(prospectId), request);

export const deleteProspectLink = (prospectId: string, linkId: string): Promise<void> =>
  del<void>(`${basePath(prospectId)}/${linkId}`);
